
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja/pelaksanaan/dokumen-tindak-lanjut/detail",
      function () {
        return require("private-next-pages/pengelolaan-kinerja/pelaksanaan/dokumen-tindak-lanjut/detail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja/pelaksanaan/dokumen-tindak-lanjut/detail"])
      });
    }
  